import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user';
import { ConfigService } from 'src/app/shared/services/config.service';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { Asset } from 'src/app/models/asset';
import { LibraryBrowserComponent } from 'src/app/modules/assetModule/components/library-browser/library-browser.component';
import { AdministrationComponent } from 'src/app/modules/userModule/components/profile/administration-page/administration-page.component';
import { environment } from '../../../environments/environment';
import { ApplicationNamePipe } from '../../shared/pipe/application-name/user-group.pipe';
import { WizardService } from 'src/app/modules/userModule/shared/wizard.service';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.css']
})
export class WizardComponent implements OnInit {
  loggedInUser: User = new User();
  isWizardActive = false;
  isThisLastWizard = false;
  wizardLinkValue = 'Next';
  hasUploadAccess = false;
  index = 0;
  wizardData: any;
  closePermanently = false;

  constructor(public userService: UserService, private router: Router,
     private wizardService: WizardService, public config: ConfigService) { }

  ngOnInit() {
    if (sessionStorage.getItem('userinfo')) {
      this.loggedInUser = JSON.parse(sessionStorage.getItem('userinfo')) as User;
    }
    this.doesUserHasPermission();
    this.loadCurrentWizard();
    this.isLastWizard();
    if (sessionStorage.getItem('isWizardClosedTemporarily') === 'true') {
      this.isWizardActive = false;
    }
  }

  loadCurrentWizard() {
    this.wizardService.currentWizard
      .subscribe(data => {
        this.wizardData = data;
        console.log(this.wizardData);
        this.isWizardActive = Object.keys(this.wizardData).length > 0;
      });
  }
  isLastWizard() {
    this.isThisLastWizard = this.wizardService.isLastWizard();
    console.log('isThisLastWizard: ', this.isThisLastWizard);
    if (this.isThisLastWizard) {
      this.wizardLinkValue = 'Finish';
    } else {
      this.wizardLinkValue = 'Next';
    }
  }

  nextWizard($event) {
    if (this.isThisLastWizard) {
      this.closeWizardTemporarily($event);
    } else {
      if (!this.hasUploadAccess) {
        this.wizardService.skipWizard();
      }
        this.wizardService.nextWizard();
        $event.preventDefault();
    }
    this.isLastWizard();
  }

  doesUserHasPermission() {
    if (this.loggedInUser.userGroup === 'Admin' || this.loggedInUser.userGroup === 'L1') {
      this.hasUploadAccess = true;
      console.log('User has permission');
    }
  }

  closeWizardPermanently($event) {
    console.log('Close wizard permanently');
    this.userService.updateWizardStatus(this.userService.loggendInUser.userEmailId).subscribe(
      result => {
        if ( result !== null) {
          console.log('Wizard updated');
          sessionStorage.setItem('isWizardClosedTemporarily', 'true');
          this.isWizardActive = false;
        }
      }
    );
  }

  closeWizardTemporarily($event) {
    sessionStorage.setItem('isWizardClosedTemporarily', 'true');
    this.isWizardActive = false;
    $event.preventDefault();
  }

  closePermanentlyOptionOpted($event) {
    setTimeout(() => {
      this.closePermanently = $event.target.active;
      console.log($event.target.active);
    }, 1000);
  }

  closeWizard($event) {
    if (this.closePermanently) {
      this.closeWizardPermanently($event);
    } else {
      this.closeWizardTemporarily($event);
    }
  }
}
